/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-10-04T13:45:39+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-10-04T14:28:18+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MErrorGroupInput from './MErrorGroupInput';
import AErrorInput from './AErrorInput';

function mapErrors(errors) {
  if (typeof errors !== 'object') {
    return null;
  }
  const errorElements = [];
  for (const key in errors) {
    if (errors.hasOwnProperty(key)) {
      errorElements.push(
          React.createElement(AErrorInput, {key}, errors[key])
      );
    }
  }
  return errorElements;
}


/**
 * MBoxErrorMessages - …
**/
class MBoxErrorMessages extends Component {
  render() {
    const {
      errors,
    } = this.props;

    return (
      <div className="m-box m-box-error-messages">
        <MErrorGroupInput>
          {mapErrors(errors)}
        </MErrorGroupInput>
      </div>
    );
  }
}

MBoxErrorMessages.propTypes = {
  errors: PropTypes.object,
};
MBoxErrorMessages.defaultProps = {};
export default MBoxErrorMessages;

